import { cn } from '@/utils';
import React, { memo } from 'react';

import { Switch as AntSwitch, SwitchProps } from 'antd';

export interface ISwitch extends SwitchProps {
	label?: string;
	containerClassName?: string;
}
const Switch: React.FC<ISwitch> = ({
	label,
	containerClassName,
	className,
	value,
	onChange,
	checkedChildren = 'ON',
	unCheckedChildren = 'OFF',
	...restProps
}) => {
	return (
		<div className={cn('flex items-center gap-2 h-[30px]', containerClassName)}>
			{label && <span className="text-[13px] text-font3">{label}</span>}
			<AntSwitch
				className={className}
				checked={value}
				onChange={onChange}
				checkedChildren={checkedChildren}
				unCheckedChildren={unCheckedChildren}
				{...restProps}
			/>
		</div>
	);
};

export default memo(Switch);
